import { buildRibbonName } from '../../ribbons/helpers/build-ribbon-name'
import { OrderItemRowResolver } from './types'

function round2(value: number): number {
    return Math.round(value * 100) / 100
}

export const ribbonOrderItemRowResolver: OrderItemRowResolver = item => {
    const sellPrice = item.ribbon?.cost?.sellPrice ?? item.approvedPrice
    const rollsCount = item.ribbon?.specs?.rollsCount ?? item.quantity

    const price =
        sellPrice != null && rollsCount != null
            ? round2(Number(sellPrice) * Number(rollsCount))
            : undefined

    return {
        name: item.name || buildRibbonName(),
        quantity: rollsCount ?? item.quantity,
        price,
    }
}
